import { Trans } from 'react-i18next';

export const bankInfo = (t) => [
    {
        key: "HKD",
        title: t("Constant.Bank_Title"),
        subtitle: t("Constant.hk_Bank"),
        bank: "HSBC",
        account: "005-4-126263",
        name: "LAM Ming Yu",
    },
    {
        key: "TWD",
        title: t("Constant.Bank_Title"),
        subtitle: t("Constant.tw_Bank"),
        bank: t("Constant.tw_BankName"),
        account: "901566675890",
        name: "彭莞容",
        // shiftcode: "006",
    },
    {
        key: "CNY",
        title: t("Constant.Bank_Title"),
        subtitle:
            <Trans key="constant" html="br:<br/>">
                {t("Constant.CNY")}
            </Trans>
        ,
        // image: "/retreat-my/images/cnyqr.jpg"
    },
    {
        key: "SGD",
        title: t("Constant.Bank_Title"),
        subtitle: t("Constant.sg_Bank"),
        bank: "POSB",
        account: "441-25956-5",
        name: "CHANG XIU MEI",
    },
    {
        key: "MYR",
        title: t("Constant.Bank_Title"),
        subtitle: t("Constant.msia_Bank"),
        image: "/retreat-my/images/qr.jpeg",
        bank: "Public Bank Berhad",
        account: "3814714401",
        name: "Pertubuhan Meditasi Shi Ne Ling Malaysia",
        shiftcode: "PBBEMYKL",
    },
];

export const retreatSessions = (t) => [
    {
        key: "Luangpu Pramote Pamojjo",
        title: t("Constant.Luangpu"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Phra Ajahn Somchai Kittiyano",
        title: t("Constant.Ajahn_Somchai"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Phra Ajahn Krit Nimmalo",
        title: t("Constant.Ajahn_Krit"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Ajahn Khun Mae Oranuch Santayakorn",
        title: t("Constant.Ajahn_KhunMae"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Phra Wannop Khunawanno (Kruba Nop)",
        title: t("Constant.KrubaNop"),
        description: "ajahnTeaching",
        mode: "online"
    },
    {
        key: "Phra Thanusorn Jirasarano (Kruba Mon)",
        title: t("Constant.KrubaMon"),
        description: "ajahnTeaching",
        mode: "online"
    },
    {
        key: "Ajahn Kittiya Pholkerd (Ajahn Ooi)",
        title: t("Constant.Ajahn_Ooi"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Ajahn Nitiya Petchpaibool",
        title: t("Constant.Ajahn_Nitiya"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Ajahn Prasan Bhuddhakulsomsiri",
        title: t("Constant.Ajahn_Prasan"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Ajahn Nat Sriwachirawat",
        title: t("Constant.Ajahn_Nat"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Ajahn Napatpol Kunatanasate (Ajahn Song)",
        title: t("Constant.Ajahn_Song"),
        description: "ajahnTeaching",
        mode: "hybrid"
    },
    {
        key: "Morning Chanting",
        title: t("Constant.Morning_Chanting"),
        description: "chanting",
        mode: "hybrid"
    },
    {
        key: "Evening Chanting",
        title: t("Constant.Evening_Chanting"),
        description: "chanting",
        mode: "hybrid"
    },
    {
        key: "Transference of Merit and Repentance",
        title: t("Constant.Transference_of_Merit"),
        description: "chanting",
        mode: "hybrid"
    },
    {
        key: "DVD",
        title: t("Constant.DvdDescription"),
        description: "dvd",
        mode: "hybrid"
    },
]


export const interviewNumbering = (t) => [
    {
        key: "first_choice",
        displayNumbering: t("Constant.one"),
    },
    {
        key: "second_choice",
        displayNumbering: t("Constant.two"),
    },
    {
        key: "third_choice",
        displayNumbering: t("Constant.three"),
    },
    {
        key: "fourth_choice",
        displayNumbering: t("Constant.four"),
    },
    {
        key: "fifth_choice",
        displayNumbering: t("Constant.five"),
    },
    {
        key: "sixth_choice",
        displayNumbering: t("Constant.six"),
    },
    {
        key: "seventh_choice",
        displayNumbering: t("Constant.seven"),
    },
    {
        key: "eighth_choice",
        displayNumbering: t("Constant.eight"),
    },
    {
        key: "ninth_choice",
        displayNumbering: t("Constant.nine"),
    },
    // -------------------------------- !!!! comment it according to interview ajahn
    // {
    //     key: "tenth_choice",
    //     displayNumbering: t("Constant.ten"),
    // }
]

export const learningAjahnNumbering = (t) => [
    {
        key: "first_choice_learning",
        displayNumbering: t("Constant.one"),
    },
    {
        key: "second_choice_learning",
        displayNumbering: t("Constant.two"),
    },
    {
        key: "third_choice_learning",
        displayNumbering: t("Constant.three"),
    },
    {
        key: "fourth_choice_learning",
        displayNumbering: t("Constant.four"),
    },
    {
        key: "fifth_choice_learning",
        displayNumbering: t("Constant.five"),
    }
]

export const identity = {
    lay: "Lay Practitioner (lay person)",
    sangha: "Sangha Member (monastics)"
}

export const passport = (t) => [
    {
        key: "Australia",
        country: t("Constant.AUS"),
        countryCodeLabel: "+61 (Australia)",
        countryCodeValue: 61,
    },
    {
        key: "Canada",
        country: t("Constant.CAN"),
        countryCodeLabel: "+1 (Canada)",
        countryCodeValue: 1,
    },
    {
        key: "China",
        country: t("Constant.CHN"),
        countryCodeLabel: "+86 (China)",
        countryCodeValue: 86,
    },
    {
        key: "Hong Kong SAR",
        country: t("Constant.HKG"),
        countryCodeLabel: "+852 (Hong Kong)",
        countryCodeValue: 852,
    },
    {
        key: "Indonesia",
        country: t("Constant.IDN"),
        countryCodeLabel: "+62 (Indonesia)",
        countryCodeValue: 62,
    },
    {
        key: "India",
        country: t("Constant.IND"),
        countryCodeLabel: "+91 (India)",
        countryCodeValue: 91,
    },
    {
        key: "Japan",
        country: t("Constant.JPN"),
        countryCodeLabel: "+81 (Japan)",
        countryCodeValue: 81,
    },
    {
        key: "Korea",
        country: t("Constant.KOR"),
        countryCodeLabel: "+82 (Korea)",
        countryCodeValue: 82,
    },
    {
        key: "Malaysia",
        country: t("Constant.MYS"),
        countryCodeLabel: "+60 (Malaysia)",
        countryCodeValue: 60,
    },
    {
        key: "Macau SAR",
        country: t("Constant.MAC"),
        countryCodeLabel: "+853 (Macau)",
        countryCodeValue: 853,
    },
    {
        key: "Myammar",
        country: t("Constant.MMR"),
        countryCodeLabel: "+95 (Myammar)",
        countryCodeValue: 95,
    },
    {
        key: "Singapore",
        country: t("Constant.SGP"),
        countryCodeLabel: "+65 (Singapore)",
        countryCodeValue: 65,
    },
    {
        key: "Sri Lanka",
        country: t("Constant.LKA"),
        countryCodeLabel: "+94 (Sri Lanka)",
        countryCodeValue: 94,
    },
    {
        key: "Taiwan",
        country: t("Constant.TWN"),
        countryCodeLabel: "+886 (Taiwan)",
        countryCodeValue: 886,
    },
    {
        key: "Thailand",
        country: t("Constant.THA"),
        countryCodeLabel: "+66 (Thailand)",
        countryCodeValue: 66,
    },
    {
        key: "United States",
        country: t("Constant.USA"),
        countryCodeLabel: "+1 (United States)",
        countryCodeValue: 1,
    },
    {
        key: "United Kingdom",
        country: t("Constant.UK"),
        countryCodeLabel: "+44 (United Kingdom)",
        countryCodeValue: 44,
    },
    {
        key: "Vietnam",
        country: t("Constant.VNM"),
        countryCodeLabel: "+84 (Vietnam)",
        countryCodeValue: 84,
    }
]

export const state = (t) => [
    { key: "Johor", state: t("Constant.johor") },
    { key: "Kedah", state: t("Constant.kedah") },
    { key: "Kelantan", state: t("Constant.kelantan") },
    { key: "Malacca", state: t("Constant.malacca") },
    { key: "Negeri Sembilan", state: t("Constant.negeriSembilan") },
    { key: "Pahang", state: t("Constant.pahang") },
    { key: "Penang", state: t("Constant.penang") },
    { key: "Perak", state: t("Constant.perak") },
    { key: "Perlis", state: t("Constant.perlis") },
    { key: "Sabah", state: t("Constant.sabah") },
    { key: "Sarawak", state: t("Constant.sarawak") },
    { key: "Selangor", state: t("Constant.selangor") },
    { key: "Terengganu", state: t("Constant.terengganu") },
    { key: "Kuala Lumpur", state: t("Constant.kualaLumpur") },
    { key: "Labuan", state: t("Constant.labuan") },
    { key: "Putrajaya", state: t("Constant.putrajaya") },
];

export const currency = (t) => [
    {
        key: "MYR",
        currency: t("accomodation.msia_Currency"),
        rate: 1.0
    },
    {
        key: "SGD",
        currency: t("accomodation.sgd_Currency"),
        rate: 0.3279
    },
    {
        key: "CNY",
        currency: t("accomodation.cny_Currency"),
        rate: 1.8163
    },
    {
        key: "TWD",
        currency: t("accomodation.twd_Currency"),
        rate: 8.0373
    },
    {
        key: "HKD",
        currency: t("accomodation.hkd_Currency"),
        rate: 2.0287
    }
]

export const invoiceItem = (t) => [
    {
        key: "twin_1p",
        title: t("Constant.TwinRoomSingleOccupancy"),
        titleForHotelDocDownload: "Twin Room\nSingle Occupancy",
        titleForReceiptDownload: "雙床房 - 單人間 (Twin Room - 1P)",
        amount: 2180
    },
    {
        key: "twin_2p",
        title: t("Constant.TwinRoom"),
        titleForHotelDocDownload: "Twin Room\nDouble Occupancy",
        titleForReceiptDownload: "雙床房 - 雙人間 (Twin Room - 2P)",
        amount: 2180
    },
    {
        key: "king_2p",
        title: t("Constant.KingRoomDoubleOccupancy"),
        titleForHotelDocDownload: "King Room\nDouble Occupancy",
        titleForReceiptDownload: "大床房 - 雙人間 (King Room - 2P)",
        amount: 2180
    },
    {
        key: "king_1p",
        title: t("Constant.KingRoom"),
        titleForHotelDocDownload: "King Room\nSingle Occupancy",
        titleForReceiptDownload: "大床房 - 單人間 (King Room - 1P)",
        amount: 2780
    },
    {
        key: "familyroom",
        title: t("Constant.FamilyRoom"),
        amount: 1950,
        titleForHotelDocDownload: "Family Room",
        titleForReceiptDownload: "家庭房 (Family Room)",
    },
    {
        key: "2-bedroomsuit",
        title: t("Constant.TwoBedroomSuite"),
        titleForHotelDocDownload: "Two Bedroom Suite",
        titleForReceiptDownload: "兩臥室套房 (Two Bedroom Suite)",
    },
    {
        key: "deluxesuit",
        title: t("Constant.DeluxeSuite"),
        titleForHotelDocDownload: "Deluxe Suite",
        titleForReceiptDownload: "豪華套房 Deluxe Suite",
    },
    {
        key: "juniorsuit",
        title: t("Constant.JuniorSuite"),
        titleForHotelDocDownload: "Junior Suite",
        titleForReceiptDownload: "行政套房 Junior Suite",
    },
    {
        key: "earlyStay",
        title: t("Constant.earlyStay"),
        amount: 240
    },
    {
        key: "earlyStaySingleRoom",
        title: t("Constant.earlyStay"),
        amount: 240
    },
    {
        key: "earlyStayFamilyRoom",
        title: t("Constant.earlyStay"),
        amount: 360
    },
    {
        key: "extendStay",
        title: t("Constant.extendStay"),
        amount: 240
    },
    {
        key: "tourismTax",
        title: t("Constant.tourismTax"),
        amount: 10
    },
    {
        key: "transactionFee",
        title: t("Constant.transactionFee"),
        amount: 20
    },
    {
        key: "sustainabilityFee",
        title: t("Constant.sustainabilityFee"),
        amount: 7
    },
];

export const courseList = (t) => [
    {
        category: 'thai_course',
        label: t("Experience.thai_course")
    },
    {
        category: 'malaysia_course',
        label: t("Experience.malaysia_course")
    },
    {
        category: 'china_study_group',
        label: t("Experience.china_course"),
    },
    {
        category: 'taiwan_course',
        label: t("Experience.taiwan_course")
    },
    {
        category: 'singapore_course',
        label: t("Experience.singapore_course"),
    },
    {
        category: 'international_english_course',
        label: t("Experience.international_english_course"),
    },
    {
        category: 'online_course',
        label: t("Experience.online_course"),
    },
]